<template>
  <div class="home">
    <transition
      name="fade"
      mode="in-out"
      type="transition"
      :duration="{ enter: 1000, leave: 1000 }"
      appear
    >
      <PopUp
        key="popup"
        :imagem="popup.imagem"
        :link="popup.link"
        :ativo="ativoComp"
        :class="popup.ativo ? 'freeze' : ''"
        @fechar="popup.ativo = !popup.ativo"
      />
    </transition>
    <div>
      <!-- <MainHeader /> -->
      <Header />
    </div>
    <div class="main-slider-holder">
      <MainSlider />
      <BarraAcesso />
    </div>
    <div class="conteudo-home">
      <div class="isLoadingHome" v-if="carregando">
        <home-loading />
        <mobile-loading />
      </div>

      <div class="conteudo-materiais">
        <div class="materiais-destaque" v-if="!carregando">
          <h1 class="materia-titulo divider">Alerta Máximo</h1>

          <ul class="materias">
            <li class="maiores" v-for="materia in firstsDestaques" :key="materia.codigo">
              <template>
                <router-link
                  :to="getLinkMateria(materia)"
                >
                  <article class="materia">
                    <div class="capa-materia">
                      <span class="categoria">{{ materia.categoria.descricao }}</span>
                      <img
                        v-if="materia.imagem"
                        :src="materia.imagem"
                        :alt="materia.titulo"
                        class="imagem-destaque"
                      />
                      <img
                        v-else
                        src="@/assets/imgs/no-image-portal.jpg"
                        :alt="materia.titulo"
                        class="imagem-destaque"
                      />
                    </div>
                    <div class="texto-materia">
                      <h2>{{ materia.titulo }}</h2>
                      <p>{{ materia.resumo }}</p>
                    </div>
                  </article>
                </router-link>
              </template>
            </li>
          </ul>
        </div>

        <div class="materiais-vendas" v-if="!carregando">
          <h1 class="materia-titulo">Impulsione suas vendas</h1>

          <ul class="materias">
            <li class="menores" v-for="materia in impulsioneVendasNoticiasLimite" :key="materia.codigo">
              <template>
                <router-link
                  :to="{ name: 'se-liga', params: { noticia: materia.slug } }"
                >
                  <article class="materia">
                    <div class="capa-materia">
                      <span class="categoria">{{ materia.categoria.descricao }}</span>
                      <img
                        v-if="materia.imagem"
                        :src="materia.imagem"
                        :alt="materia.titulo"
                        class="imagem-destaque"
                      />
                      <img
                        v-else
                        src="@/assets/imgs/no-image-portal.jpg"
                        :alt="materia.titulo"
                        class="imagem-destaque"
                      />
                    </div>
                    <div class="texto-materia">
                      <h2>{{ materia.titulo }}</h2>
                      <p>{{ materia.resumo }}</p>
                    </div>
                  </article>
                </router-link>
              </template>
            </li>
          </ul>
        </div>
      </div>
      <div class="conteudo-lateral">

        <BarraLateral />

        <FaleConosco/>
      </div>
    </div>

    <div class="main-footer-holder">
      <MainFooter />
    </div>
    <botao-voltar-topo />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeader from '@/components/layout/header/MainHeader.vue';
import Header from '@/components/layout/header/Header.vue';
import MainSlider from '@/components/layout/slider/MainSlider.vue';
import BarraLateral from '@/components/layout/conteudo/BarraLateral.vue';
import MainFooter from '@/components/layout/footer/MainFooter.vue';
import BotaoVoltarTopo from '@/components/BotaoVoltarTopo.vue';
import PopUp from '@/components/PopUp.vue';
import mixins from '@/helpers/mixins';
import HomeLoading from '@/components/Loading/HomeLoading';
import MobileLoading from '@/components/Loading/MobileLoading';
import SliderMiniaturas from '@/components/layout/slider/SliderMiniaturas.vue';
import BarraAcesso from '@/components/BarraAcesso/BarraAcesso';
import FaleConosco from '@/components/layout/conteudo/FaleConosco.vue';

export default {
  name: 'home',
  mixins: [mixins],
  components: {
    Header,
    // MainHeader,
    MainSlider,
    BarraLateral,
    MainFooter,
    BotaoVoltarTopo,
    HomeLoading,
    MobileLoading,
    PopUp,
    SliderMiniaturas,
    BarraAcesso,
    FaleConosco
  },
  data() {
    return {
      limit: 12,
      popupOn: true,
      popup: {
        imagem: 'zz_placeholder_img18',
        ativo: false,
        link: '',
      },
    };
  },
  computed: {
    ativoComp() {
      return this.popup.ativo;
    },
    firstsDestaques() {
      return this.destaques.filter((destaque, index) => index < 3);
    },
    otherDestaques() {
      return this.destaques.filter((destaque, index) => index >= 3);
    },
    impulsioneVendasNoticiasLimite() {
      return this.impulsioneVendasNoticias.slice(0, 9)
    },
    ...mapGetters({
      carregando: 'home/carregando',
      destaques: 'home/destaques',
      canal: 'home/canal',
      uf: 'user/uf',
      impulsioneVendasNoticias: 'home/impulsioneVendasNoticias',
    }),
    getLinkMateria() {
      return (materia) => (materia.vivo_se_liga === true || materia.vivo_se_liga === 1)
        ? { name: 'se-liga', params: { noticia: materia.slug } }
        : { path: `/categoria/${materia.categoria.slug}/post/${materia.slug}` };
    },
  },
  methods: {
    ...mapActions({
      getDestaques: 'home/getDestaques',
      getHomePageNoticias: 'home/getHomePageNoticias',
      setTitle: 'apiRoute/setTitle',
      getHomeImpulsioneVendasNoticias: 'home/getHomeImpulsioneVendasNoticias',
    }),
    setarPopupAtivo() {
      setTimeout(() => {
        this.popup.ativo = !this.popup.ativo;
      }, 500);
    },
    fechar() {
      this.popup.ativo = !this.popup.ativo;
    },
  },
  async mounted() {
    await this.getHomePageNoticias(this.limit);
    await this.getHomeImpulsioneVendasNoticias();
    await this.setTitle({ title: '' });
    this.popupOn ? this.setarPopupAtivo() : '';
  },
  watch: {
    uf() {
      this.getHomePageNoticias(this.limit);
      this.getHomeImpulsioneVendasNoticias();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

$largura-foto-grande: 290px;
$altura-foto-grande: 185px;
$largura-foto-pequena: 190px;
$altura-foto-pequena: 110px;

.main-slider-holder {
  background: url(../../assets/imgs/pattern_header.png);
  width: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding-bottom: 20px;
}

.conteudo-home {
  position: relative;
  @extend %flex;
  @extend %direction-row;
  @extend %justify-between;
  @extend %area-de-utilizacao;
  margin: 0 auto;
  margin-top: 15px;

  .materia-titulo {
    color: $cor_roxo;
    display: flex;
    align-items: center;
    gap: 8px;

    &.divider {
      border-bottom: 1px solid $cor_cinza_medium;
    }
  }

  & .isLoadingHome {
    position: absolute;
    top: 0;
    left: 0;
    width: 600px;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
  }

  & .materias {
    @extend %flex;
    @extend %direction-row;
    @extend %justify-between;
    @extend %flex-wrap;
    width: 600px;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;

    & li:nth-child(2) {
      margin-right: 3.33%;
    }

    & .menores:nth-child(4) {
      margin-right: 15px;
    }
    & .menores:nth-child(5) {
      margin-right: auto;
    }
    & .menores:nth-child(7) {
      margin-right: 15px;
    }
    & .menores:nth-child(8) {
      margin-right: auto;
    }
    & .menores:nth-child(10) {
      margin-right: 15px;
    }
    & .menores:nth-child(11) {
      margin-right: auto;
    }

    & li {
      &:hover * {
        color: $cor_rosa !important;
      }

      & a {
        margin: 0px;
        padding: 0px;
        text-decoration: none;
        cursor: pointer;

        & article {
          @extend %flex;
          @extend %direction-row;
          @extend %justify-between;
          @extend %align-items-center;
          width: 600px;
          margin-bottom: 30px;

          & .capa-materia {
            user-select: none;
            min-width: $largura-foto-grande;
            max-width: $largura-foto-grande;
            height: $altura-foto-grande;
            border-radius: 5px;
            position: relative;

            &:hover {
              transition: 0.3s ease;
              @extend %gradiente_twilight;
            }

            &:hover {
              transform: scale(1.03);

              & > .categoria {
                background: transparent;
                font-size: 13px;
                // color: transparent;
                // border: 1px solid white;
              }
            }

            & .categoria {
              position: absolute;
              font-size: 10px;
              top: 3px;
              left: 3px;
              color: white !important;
              padding: 0px 3px;
              border-radius: 3px;
              font-weight: 600;
              // @extend %gradiente_rosa;
              background: $cor_rosa;
              opacity: 1 !important;
              z-index: 99;
              transition: all 0.2s ease-in-out;
            }

            & img:hover {
              transition: 0.3s ease;
              opacity: 0.3;
            }

            & .imagem-destaque {
              transition: 0.5s ease;
              object-fit: cover;
              width: 100%;
              height: $altura-foto-grande;
              border-radius: 5px;
            }
          }

          & .texto-materia {
            min-width: $largura-foto-grande;
            max-width: $largura-foto-grande;

            & h2 {
              font-family: 'VivoType';
              font-weight: 800;
              color: $cor_cinza_dark;
              font-size: 26px;
              line-height: 28px;
              // letter-spacing: 0.01vmax;
              margin: 0px;
              margin-bottom: 10px;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              line-clamp: 3;
              -webkit-box-orient: vertical;
              -o-text-overflow: ellipsis;
              -ms-text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }

            & p {
              font-size: 15px;
              line-height: 19px;
              margin: 0px;
              font-family: "Trebuchet MS";
              color: $cor_cinza_dark;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }

    & .maiores:nth-child(2),
    .maiores:nth-child(3) {
      & a {
        & article {
          @extend %flex;
          @extend %direction-column;
          @extend %justify-between;
          @extend %align-items-center;
          width: 100%;
          margin-bottom: 40px;

          & .texto-materia {
            margin-top: 15px;

            & h2 {
              font-size: 23px;
              line-height: 25px;
              margin-bottom: 8px;
            }

            & p {
              font-size: 13px;
            }
          }
        }
      }
    }

    & .menores {
      border-top: 1px solid $cor_cinza_medium;
      // border-bottom: 1px solid $cor_cinza_medium;
      padding-top: 20px;

      & a {
        & article {
          @extend %flex;
          @extend %direction-row;
          @extend %justify-between;
          @extend %align-items-center;
          @extend %flex-wrap;
          width: $largura-foto-pequena;
          margin-bottom: 20px;

          & .capa-materia {
            min-width: $largura-foto-pequena;
            max-width: $largura-foto-pequena;
            height: 110px;

            & .imagem-destaque {
              height: 110px;
            }
          }

          & .texto-materia {
            margin-top: 10px;
            min-width: $largura-foto-pequena;
            max-width: $largura-foto-pequena;

            & h2 {
              font-size: 17px;
              line-height: 20px;
            }

            & p {
              font-size: 10px;
              display: none;
            }
          }
        }
      }
    }

    & .banner {
      user-select: none;
      padding-bottom: 50px;

      & img {
        transition: all 0.2s ease-in-out;

        &:hover {
          transform: scale(1.025);
        }
      }
    }
  }
}

.conteudo-lateral {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.main-footer-holder {
  padding: 40px 0px 0px;
  margin-top: 30px;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}

// .fade-enter {opacity: 0}
// .fade-enter-to {opacity: 1}
// .fade-enter-active {transition: opacity .5s ease-in-out}

// .fade-leave {opacity: 1}
// .fade-leave-to {opacity: 0}
// .fade-leave-active {transition: opacity .5s ease-in-out}

@media all and (min-width: 300px) and (max-width: 679px) {
  .main-slider-holder {
    background: url(../../assets/imgs/pattern_header.png);
    background-repeat: no-repeat;
    background-size: cover;
  }

  .conteudo-home {
    flex-direction: column !important;
    justify-content: flex-start !important;
    align-items: center !important;
    max-width: 100vw;
    margin: 0 auto;
    // margin-top: calc((((50vw + 50vh) * 2) / 40) + 0px);

    & .isLoadingHome {
      position: relative;
      width: 80vw;
    }

    & .materias {
      flex-direction: column;
      justify-content: flex-start;
      width: 80vw;

      & :nth-child(4) {
        margin-right: 0px;
      }
      & :nth-child(5) {
        margin-right: 0px;
      }
      & :nth-child(7) {
        margin-right: 0px;
      }
      & :nth-child(8) {
        margin-right: 0px;
      }

      & li {
        & a {
          & article {
            flex-direction: column !important;
            justify-content: flex-start !important;
            width: 80vw !important;
            margin-bottom: calc((((100vw + 100vh) * 2) / 80) + 10px) !important;

            & .capa-materia {
              min-width: 80vw !important;
              max-width: 80vw !important;
              height: 5.5% !important;

              &:hover {
                transform: scale(1.02) !important;

                & > .categoria {
                  font-size: calc(
                    (((100vw + 100vh) * 2) / 250) + 8px
                  ) !important;
                }
              }

              & .categoria {
                font-size: calc((((100vw + 100vh) * 2) / 300) + 4px) !important;
              }

              & .imagem-destaque {
                height: 5.5% !important;
              }
            }

            & .texto-materia {
              margin: 0px !important;
              min-width: 100% !important;
              max-width: 100% !important;

              & h2 {
                font-size: calc((((100vw + 100vh) * 2) / 170) + 6px) !important;
                line-height: calc(
                  (((100vw + 100vh) * 2) / 170) + 8px
                ) !important;
                margin: 3% 0 2% !important;
              }

              & p {
                font-size: calc((((100vw + 100vh) * 2) / 240) + 3px) !important;
              }
            }
          }
        }
      }

      & li:nth-child(n + 4) {
        border: 0px;
        padding-top: 0px;

        & a {
          & article {
            & .texto-materia {
              & p {
                font-size: calc((((100vw + 100vh) * 2) / 240) + 3px);
                display: block;
              }
            }
          }
        }
      }
    }
  }

  .main-footer-holder {
    padding: 0px;
    margin-top: 30px;
  }

  & .banner {
    & img {
      max-width: 100%;
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .main-slider-holder {
    background: url(../../assets/imgs/pattern_header.png);
    background-repeat: no-repeat;
    background-size: cover;
  }

  .conteudo-home {
    flex-direction: column !important;
    align-items: center !important;
    margin: 0 auto;

    & .isLoadingHome {
      min-height: 100vh;
      opacity: 0;
    }

    & .materias {
      & li {
        & a {
          & article {
            & .capa-materia {
              height: 5.5% !important;

              &:hover {
                transform: scale(1.02) !important;
              }
            }
          }
        }
      }
    }
  }

  .main-footer-holder {
    padding: 0px;
    margin-top: 30px;
  }
}
</style>
